// extracted by mini-css-extract-plugin
module.exports = {"textCenter":"utilities-module--textCenter--146Ac","margin0":"utilities-module--margin0--3b_0V"};